import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-118">
      <div className="flex flex-col md:flex-row gap-8 items-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="w-full md:w-1/2 space-y-6" data-id="element-120">
          <h2 className="font-handwriting text-4xl md:text-5xl lg:text-6xl text-forest leading-tight font-bold" data-id="element-121">
            "Mein Hund hatte so schlimme Blähungen – ich schämte mich beim Gassi
            gehen"
          </h2>
          <p className="font-serif text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-122">
            Was ich nach monatelanger Suche entdeckt habe – und warum ich es
            früher hätte wissen wollen.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full md:w-1/2 relative" data-id="element-123">
          <div className="absolute -inset-2 bg-brown/10 rounded-2xl transform rotate-3" data-id="element-124"></div>
          <img src="https://images.unsplash.com/photo-1587300003388-59208cc962cb?auto=format&fit=crop&q=80&w=1000" alt="Ein süßer Labrador Retriever, der gemütlich liegt" className="relative z-10 w-full h-auto rounded-xl shadow-lg object-cover aspect-square md:aspect-[4/3]" data-id="element-125" />
        </motion.div>
      </div>
    </section>;
}